document.addEventListener('DOMContentLoaded', function() {
  const infoIcon = document.querySelector('.resolution-info-icon-wrapper');
  
  if (infoIcon) {
    infoIcon.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const resolutionModal = document.querySelector('#downloadModal.resolution-info-modal');
      
      if (resolutionModal) {
        resolutionModal.style.display = 'block';
        document.body.style.overflow = 'hidden';
        
        resolutionModal.classList.remove('closing');
        
        void resolutionModal.offsetWidth;
      }
    });
  }
  
  window.hideResolutionInfo = function(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    const resolutionModal = document.querySelector('#downloadModal.resolution-info-modal');
    
    if (resolutionModal && resolutionModal.style.display === 'block') {
      resolutionModal.classList.add('closing');
      
      setTimeout(function() {
        resolutionModal.style.display = 'none';
        resolutionModal.classList.remove('closing');
        document.body.style.overflow = '';
      }, 300);
    }
  };
  
  const resolutionModal = document.querySelector('#downloadModal.resolution-info-modal');
  if (resolutionModal) {
    resolutionModal.addEventListener('click', function(e) {
      if (e.target === resolutionModal || e.target.classList.contains('modal-content')) {
        window.hideResolutionInfo(e);
      }
    });
  }
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const resolutionModal = document.querySelector('#downloadModal.resolution-info-modal');
      if (resolutionModal && resolutionModal.style.display === 'block') {
        window.hideResolutionInfo(e);
      }
    }
  });
});
